import kebabCase from 'lodash/kebabCase';
import {
    isEnabled as isEnabledOnBrowser,
    isMultiVariationEnabled as isMultiVariationEnabledOnBrowser
} from './strategies/browser-strategy';
import {
    isEnabled as isEnabledOnServer,
    isMultiVariationEnabled as isMultiVariationEnabledOnServer
} from './strategies/server-strategy';

declare const __isBrowser__: boolean;

const isFeatureFlagEnabled = __isBrowser__
    ? isEnabledOnBrowser
    : isEnabledOnServer;

const isMultiVariationEnabled = __isBrowser__
    ? isMultiVariationEnabledOnBrowser
    : isMultiVariationEnabledOnServer;

export async function isPublishingEnabled() {
    return await isFeatureFlagEnabled('publishing-pipeline-enabled', false);
}

export async function isUnpublishingEnabled() {
    return await isFeatureFlagEnabled('unpublishing-pipeline-enabled', false);
}

export async function isLocalizationTagsEnabled(
    productSlug: string
): Promise<boolean> {
    const localizedContext = await isMultiVariationEnabled(
        'enable-localization',
        false
    );
    return localizedContext[kebabCase(productSlug)];
}

export async function isRedirectEnabledByContentType(
    contentType: string
): Promise<boolean> {
    const supportedTypes = await isMultiVariationEnabled(
        'enable-redirect-dialog-by-content-type',
        false
    );

    return supportedTypes[contentType];
}

export async function isUnpublishRedirectCreationEnabled() {
    return await isFeatureFlagEnabled(
        'enable-unpublish-redirect-creation',
        false
    );
}

// this is used for testing, do not delete or use
export async function isNewFeatureEnabled() {
    return await isFeatureFlagEnabled('new-feature', false);
}

export async function isMajorAccessibilityImprovementsEnabled() {
    return await isFeatureFlagEnabled(
        'major-accessibility-improvements',
        false
    );
}

export async function isNoticeHubEnabled() {
    return await isFeatureFlagEnabled('notice-hub', false);
}

export async function isHardcodedAtlassianCloudHelpfulLinksEnabled() {
    return await isFeatureFlagEnabled(
        'hardcoded-atlassian-cloud-helpful-links',
        false
    );
}

export async function isHardcodedOpsgenieHelpfulLinksEnabled() {
    return await isFeatureFlagEnabled(
        'hardcoded-opsgenie-helpful-links',
        false
    );
}

export async function isFlattenIAEnabled() {
    return await isFeatureFlagEnabled('flatten-ia', false);
}

export async function isNamedContactsPageEnabled() {
    return await isFeatureFlagEnabled('sac-to-csp-named-contact-link', false);
}

export async function isStopRenderOfFlattenedTopicsEnabled() {
    return await isFeatureFlagEnabled('stop-render-of-flattened-topics', false);
}

export async function isThresholdTranslationSeoEnabled() {
    return await isFeatureFlagEnabled(
        'enable-threshold-translation-seo',
        false
    );
}

export async function isReleaseNoteCrawlingEnabled() {
    return await isFeatureFlagEnabled('enable-release-note-crawling', false);
}

export async function isSacCstAuthEnabled() {
    return await isFeatureFlagEnabled('sac-cst-auth-enabled', false);
}

export async function isSessionHeartbeatEnabled() {
    return await isFeatureFlagEnabled('session-heartbeat-api', false);
}

export async function isAccountSwitcherEnabled() {
    return await isFeatureFlagEnabled('account-switcher-menu', false);
}

export async function isCloudAutomationEnabled() {
    return await isFeatureFlagEnabled('cloud-automation', false);
}

export async function isSessionHeartbeatDebugApiEnabled() {
    return await isFeatureFlagEnabled('heartbeat-api-debug', false);
}

export async function isPublishListingPageEnabled() {
    return await isFeatureFlagEnabled('publish-listing-page-enabled', false);
}

export async function isCopsiEnabled() {
    return await isFeatureFlagEnabled('copsi-enabled', false);
}
